import React from 'react'
import {authRoles} from '../../auth/authRoles'

const ExpenseRoutes = [
    {
        path: '/viewer/expensedashboard',
        component: React.lazy(() => import('../ExpenseDashboards/ViewerExpenseDashboard')),
        auth: authRoles.viewerExpenseDashboard,
    },
    {
        path: '/contributor/expensedashboard',
        component: React.lazy(() => import('../ExpenseDashboards/ContributorExpenseDashboard')),
        auth: authRoles.individualContributorExpenseDashboard,
    },
    {
        path: '/orgcontributor/expensedashboard',
        component: React.lazy(() => import('../ExpenseDashboards/OrgContributorExpenseDashboard')),
        auth: authRoles.orgContributorExpenseDashboard,
    },
    {
        path: '/orgadmin/expensedashboard',
        component: React.lazy(() => import('../ExpenseDashboards/OrgAdminExpenseDashboard')),
        auth: authRoles.orgAdminExpenseDashboard,
    },
    {
        path: '/admin/expensedashboard',
        component: React.lazy(() => import('../ExpenseDashboards/AdminExpenseDashboard')),
        auth: authRoles.AdminExpenseDashboard,
    },
    {
        path: '/expense/addexpense',
        component: React.lazy(() => import('./AddExpense')),
        auth: authRoles.AddExpense,
    },
    {
        path: '/expense/reviewexpense/:id',
        component: React.lazy(() => import('./ReviewExpense')),
        auth: authRoles.reviewExpense,
    },
    
]

export default ExpenseRoutes